<template>
  <div class="page" :class="citySite==''?'VR':''"  v-wechat-title="$route.meta.title">
    <!--搜索-->
    <div class="top-fixed-box">
      <div class="station-search border-box box">
        <div class="location l clearfix" @click="toCity" v-if="searchListShow!=1">
          <img class="fl icon-dw" src="../../assets/new-index/icon-dw.png" alt="">
          <span class="fl hide city flex" v-show="loadEnd">{{cityInfo.city || '全国'}}</span>
          <img class="fl icon-d" src="../../assets/new-index/icon-d.png" alt="">
        </div>
        <div class="flex station-search-con box">
          <form class="station-search-bar border-box flex" action="." v-on:submit.prevent="search"
                @click="searchListShow=1">
            <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click.stop='search'>
            <input type="search" class="station-search-input" placeholder="搜索景区名称" value="" v-model='inputValue'/>
            <img class="station-input-close none" src="../../assets/input-close.png" alt="" v-show="inputValue"
                 @click.stop="inputValue=''">
          </form>
          <div class="search-history-cancel flex" v-if="searchListShow==1" @click.stop="searchListShow=0">取消</div>
        </div>
        <div class="search-history-list border-box" v-if="searchListShow==1">
          <p class="search-history-tit" v-if="history.length > 0">
            搜索历史 <img src="../../assets/icon_01.png" alt="" @click="delHistory"></p>
          <p class="search-history-my clearfix">
            <span v-for="(item,index) in history" @click="searchHistory(item)">{{item}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="tab-box box">
      <div class="flex" :class="tabCurr==0?'curr':''" @click="tabFun(0)"><span>全部</span></div>
      <div class="flex" :class="tabCurr==1?'curr':''" @click="tabFun(1)"><span>热门推荐</span></div>
      <div class="flex" :class="tabCurr==2?'curr':''" @click="tabFun(2)"><span>最新上线</span></div>
      <div class="flex" :class="tabCurr==3?'curr':''" @click="tabFun(3)"><span>附近景区</span></div>
    </div>
    <!--新增全景视频模块-->
    <div class="video-vr border-box" v-if="root.length>0">
      <div class="video-vr-con" v-for="(item,index) in root">
        <div class="video-vr-top" @click="goVideoVR(item.id)">
          <!--<span class="video-vr-mask"></span>-->
          <img class="icon_360" src="../../assets/icon_360.png" alt="" v-if="citySite!=1&&citySite!=''">
          <div class="video-vr-img" id="video-vr-img" v-if="citySite==''&&index==0"></div>
          <img class="video-vr-img" v-lazy="item.tvideourl" alt="" v-else>
          <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="citySite!=''">
          <div class="video-tit border-box hide" v-if="citySite!=''">{{item.name}}</div>
          <span class="video-vr-txt num" v-if="citySite!=''">{{item.listencount|initNumber}}次播放</span>
          <span class="video-vr-txt spot" v-if="citySite!=1&&citySite!=''">{{item.spotNum}}个讲解点</span>
        </div>
        <div class="video-vr-bot border-box">
          <span class="fl video-vr-name hide" v-if="citySite!=''">{{item.fname}}</span>
          <!--<span class="fl video-vr-tag" v-if="citySite==''&&index==0">推荐</span>-->
          <!--<span class="fl video-vr-tag" v-if="citySite==''&&index==1">热门</span>-->
          <span class="fl video-vr-name hide" v-if="citySite==''">{{item.name}}</span>
          <span class="fr video-vr-num">{{item.listencount|initNumber}}人收看</span>
        </div>
      </div>
    </div>
    <p class="load-tip" ref="loadtip">{{loadText}}</p>
  </div>
</template>
<script>
  import {getViewDetail, getBagTab, getCatalogue, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,citySiteVR,siteVrlist } from "@/service/getData";
  import {wxGetPosition,getCityInfo,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)
  export default {
    data(){
      return {
        siteid: this.$route.query.siteid || '',//站点id
        sregion: this.$route.query.sregion || '',//省站点id:430000
        shopid: this.$route.query.shopid || '', //景区id
        spotid: this.$route.query.spotid || '', //景点id
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        page: 1,
        rows: 7,
        loadText: "数据加载中",
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: this.$route.query.citycode||"1", city: "全部", address: "" },
        citySite: this.$route.query.citySite || '',//是否为城市站点首页跳过来 1：是  3,语音包跳过来的
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        citycode: this.$route.query.citycode || '',//城市站点code或者home页面的citycode
        root:[],//VR视频列表
        total: '',//VR视频专辑总数
        order: this.$route.query.order || 0, //0 距离  1 最新
        inputValue: '',//搜索关键词
        searchListShow: 0, //搜索历史
        history: [], //历史记录
        tabCurr:0//顶部切换curr
      }
    },
    computed: {},
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      let self = this;
      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }
      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }
      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res;
        if(this.citySite == 2){
          this.$route.meta.title = ' ';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:1,
            code:this.citycode,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 1){
          this.$route.meta.title = '视频列表';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:0,
            code:this.citycode,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 3){
          this.$route.meta.title = '视频列表';
          res = await siteVrlist({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            id: this.shopid,
            page: page,
            rows: this.rows
          });
        }else{
          this.$route.meta.title = 'VR真人讲解';
          res = await getViewVr({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid,
            spotid: this.spotid || '',
            code: this.citycode || '1',
            lat: this.latlng.lat || '',
            lng: this.latlng.lng || '',
            siteid: this.siteid,
            sregion: this.sregion,
            page: page,
            rows: this.rows,
            order: this.order
          });
        }

        if (res.errcode === '00000'){
          this.loadEnd = true;
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”，一起来听景区故事吧';
          let link = "";
          if(this.citySite && this.citySite != ""){
            link = '/video-vrlist?citycode='+ this.citycode +'&citySite='+ this.citySite +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }else {
            link = '/video-vrlist?shopid='+ this.shopid +'&spotid='+ this.spotid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }
          wxShareme(title,desc,"",link);

        }else {
          this.$toast(res.errmsg)
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //顶部切换
      tabFun(id){
        this.tabCurr = id;
      },



      //跳转到VR视频
      goVideoVR(id){
        if(this.citySite == 1){
          this.$router.push({
            path: `/video-play1?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=1'}`
          });
        }else if(this.citySite == 2){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }else{
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },

      showPhotoVR(imgurl,obj){
//            var imgurl = require('../../assets/qj.jpg');
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

      //删除历史记录
      delHistory(){
        let self = this;

        this.$confirm({
          title: '提示',
          content: '确认删除全部历史记录？',
          component: wxConfirm
        }).then(function (res) {
          if (res == 'success') {
            self.history = [];
            setStore("history", {"history": []}, 1);
          }
        }).catch(function (res) {
          if (res == 'success') {
            self.history = [];
            setStore("history", {"history": []}, 1);
          }
        })
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if (this.inputValue == '') {
          this.$toast('请输入搜索关键词')
        } else {
          if (this.history.indexOf(this.inputValue) < 0) {
            this.history.unshift(this.inputValue);
          }
          if(this.history.length > 10){
            this.history = this.history.slice(0,10);
          }
          setStore("history", {"history": this.history}, 1);
          this.searchHistory(this.inputValue);
        }
      },

      //搜索某一条
      searchHistory(inputValue){
        this.$router.push({
          path: `/home-search?${'inputValue=' + inputValue + '&TimeStamp=' + this.TimeStamp+'&siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&appKey=' + this.appKey}`
        });
      },


      toCity(){
        this.$router.push({
          path: `/city?${'siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
        });
      },

    },
    watch:  {
      root(){
        var self = this;
        this.$nextTick(function(){
          if(self.root[0].vrimg && self.root[0].vrimg != '' && self.root[0].vrimg != null && self.citySite==""){
            self.showPhotoVR(self.root[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>
<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  .page{ padding-top:1.92rem;padding-bottom: .2rem;min-height: 100vh;background-color: #ededed;}
  /*全景视频*/
  .video-vr{padding: .3rem .24rem;}
  .video-vr-con{ margin-top: .24rem; width: 100%;height: auto;border-radius: .13rem;background-color: #fff;overflow: hidden;}
  .video-vr-con:first-child{margin-top: 0;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3.88rem;border-radius: .13rem;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .13rem;object-fit: cover;}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}
  .video-vr-bot{position:relative;width:100%;height: .9rem; padding: 0 .24rem;background-color: #fff;}
  .video-vr-name{max-width:70%;font: .32rem/.9rem "Microsoft YaHei";color: #222;}
  .video-vr-num{font: .26rem/.9rem "Microsoft YaHei";color: #999;}
  .load-tip{margin-top: 0;}

  /*搜索*/
  .top-fixed-box{position:fixed;top:0;left:0;z-index:99;width:100%;height:.96rem;background:#ededed;border-bottom: 1px solid #ededed;}
  .station-search{position:absolute;top:0;left:0;width: 100%;height: 100%;padding:.16rem .3rem;background:#fff;}
  .location{margin-right: .35rem;}
  .location .icon-dw{width: .26rem;height: .32rem;vertical-align: top;margin-top: .16rem;margin-right: .06rem;object-fit: contain;}
  .location .city{display: inline-block;max-width:1.5rem;font: bold .32rem/.64rem "Microsoft YaHei";color: #222;vertical-align: top;}
  .location .icon-d{width: .2rem;height: .12rem;vertical-align: top;margin-top: .26rem;margin-left: .12rem;object-fit: contain;}
  .station-search-con{position:relative;z-index:99}
  .station-search-bar{display:block;margin-top:0;height:.64rem;border-radius:.32rem;line-height:.64rem}
  .station-search-input{left:.64rem;height:.64rem;line-height:.64rem}
  .station-search-icon{position: absolute;top: 50%;left: 0;right: inherit;z-index: 999;padding: 0.2rem 0.15rem 0.2rem 0.24rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .station-input-close{position:absolute;top:50%;right:.5rem;z-index:999;padding:.2rem;width:.19rem;height:.19rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}

  /*搜索记录*/
  .search-history-cancel{padding-left:.24rem;width:1.8rem;height:.68rem;color:#2671fb;text-align:center;font-size:.28rem;line-height:.68rem}
  .search-history-list{position:fixed;top:0;left:0;z-index:98;padding:1.48rem .3rem .3rem 0;width:100%;height:100%;background:#fff}
  .search-history-tit{position:relative;padding-left:.4rem;height:.4rem;color:#343434;line-height:.4rem}
  .search-history-tit img{position:absolute;top:.05rem;right:0;width:.28rem;height:.3rem}
  .search-history-my span{float:left;margin-top:.3rem;margin-left:.5rem;color:#000;font-size:.28rem}

  /*顶部切换分类*/
  .tab-box{position:fixed;z-index: 1;top:.96rem;left:0;width:100%;height:.96rem;text-align: center;background: #fff;}
  .tab-box .flex span{position: relative;display:inline-block;height:.96rem;font: bold .3rem/.96rem "Microsoft YaHei";color:#222;transition: all ease .2s;}
  .tab-box .flex.curr span{font-size: .34rem;}
  .tab-box .flex.curr span:after{content: '';position: absolute;bottom: .22rem;left: .1rem;right: .1rem;height: .06rem;background-color: #f99d0b;border-radius: .04rem;}
</style>
<style>
  .page.VR .psv-container{ position: absolute; padding: 1px; left:-1px; top:-1px; right:-1px; bottom:-1px; }
</style>



// WEBPACK FOOTER //
// src/page/video-vrlist/video-vrlist-new.vue